/**************************************************
 * Nombre:       Formulario_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    ApartmentOutlined,
    BadgeOutlined, Email,
    FlagOutlined,
    PhoneAndroidOutlined,
    SignpostOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOPEDIDOS} from "../../Constantes";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";

const Formulario_Pedido = ({...props}) => {
    const [subCategorias, setSubCategorias] = useState([])
    const [categorias, setCategorias] = useState([])


    useEffect(() => {

        obtenerCol('subCategorias').then((dox) => {
            if (dox.res) {
                setSubCategorias(dox.data)
            }
        })

        obtenerCol('categorias').then((dox) => {
            if (dox.res) {
                setCategorias(dox.data)
            }
        })

    }, [])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid2 container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                   opciones={ESTADOPEDIDOS.map((it) => it.nombre)}
                    />
                </Grid2>

                <Grid2 container size={6}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num Identificacion'}
                                  dato={'cc'} {...props}

                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'}
                                  dato={'nombre'} {...props}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Email} nombre={'Correo'}
                                  dato={'correo'} {...props}
                    />
                </Grid2>


                <Grid2 container size={6}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Celular'}
                                  dato={'celular'} {...props}
                    />
                </Grid2>

                <Grid2 container size={6}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Celular'}
                                  dato={'otroCelular'} {...props}
                    />
                </Grid2>


                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos en envio</Typography>
                </Grid2>


                <Grid2 container size={6}>
                    <IngresoTexto Icono={ApartmentOutlined} nombre={'Ciudad'}
                                  dato={'ciudad'} {...props}
                    />
                </Grid2>

                <Grid2 container size={6}>
                    <IngresoTexto Icono={ApartmentOutlined} nombre={'Otro'}
                                  dato={'otraCiudad'} {...props}
                    />
                </Grid2>

                <Grid2 container size={12}>
                    <IngresoTexto Icono={SignpostOutlined} nombre={'Direccion'}
                                  dato={'direccion'} {...props}
                    />
                </Grid2>

                <Grid2 container size={12}>
                    <IngresoTexto lineas={5} nombre={'Indicaciones adicionales'}
                                  dato={'indicaciones'} {...props}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Notas internas</Typography>
                </Grid2>

                <Grid2 container size={12}>
                    <IngresoTexto lineas={5} nombre={'Notas internas'}
                                  dato={'notas'} {...props}
                    />
                </Grid2>

            </Grid2>

        </form>

    )

}
export default Formulario_Pedido

